document.querySelectorAll('.you_may_like_splide').forEach((coltab) => {
  const colTab = new Splide( coltab, {
    type   : 'slide',
    gap: '3rem',
    rewind : true,
    perPage: 3,
    pagination : false ,
    breakpoints: {
      989: {
        perPage: 2,
      },
      749: {
        perPage: 1,
        focus:'center',
        padding:'20%',
        start: 1,
      }
    },
  });
 
  const bar = colTab.root.querySelector('.my-carousel-progress-bar');
  if (bar) {
    colTab.on('mounted move', function () {
      const end = colTab.Components.Controller.getEnd() + 1;
      const rate = Math.min((colTab.index + 1) / end, 1);
      bar.style.width = `${100 * rate}%`;
    });
  }

  colTab.mount();
 

});

let youmayButton = document.querySelector('.you-may-like .youmay_button');

if (youmayButton) {
  let is_jsenabled = youmayButton.dataset.enableCode
  let data_url = youmayButton.dataset.url
  let data_product_type = youmayButton.dataset.productType
  
  
  if (is_jsenabled) {
    youmayButton.addEventListener('click', function(e) {
       e.preventDefault();
      const redirectUrl = `${data_url}?product_type=${encodeURIComponent(data_product_type)}`;
      window.location.href = redirectUrl;
    });
  }
}

